export const componentStyles = (isScrolled=false) => {
    return {
        editButton: {
            ml: "auto",
        },
        mainWrapper: {
            columnGapgap: 2,
            alignItems: "flex-start",
            justifyContent: "space-between",
            flexDirection: "row",
            flexGrow: 1,
            rowGap: 5,
        },
        paper: {
            mb: 2, 
            p: 4, 
            minHeight: 100, 
            position: isScrolled ? 'sticky' : 'relative', 
            top: isScrolled ? 66 : 0, 
            zIndex: isScrolled ? 10 : 0,
            borderBottomLeftRadius: isScrolled ? 8 : 4,
            borderBottomRightRadius: isScrolled ? 8 : 4,
            borderTopLeftRadius: isScrolled ? 0 : 4,
            borderTopRightRadius: isScrolled ? 0 : 4,
            transform: isScrolled ? 'translateY(-1px)' : 'translateY(0)',
            ...(isScrolled ? {
                boxShadow: '0 6px 16px rgba(0, 0, 0, 0.15), 0 2px 6px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(0, 0, 0, 0.06)',
                backdropFilter: 'blur(10px)',
                backgroundColor: 'rgba(255, 255, 255, 0.95)',
            } : {}),
            transition: 'all 0.2s ease-in-out',
        }
    };
    
};